export const DESCRIPTION_MAX_LENGTH = 14000;
